function FilterItem(search: string, data: any) {
  return data
    ?.map((sub: any) => {

      const matchesSearch =
        sub?.slug.toLowerCase().includes(search?.toLowerCase()) ||
        sub?.name.toLowerCase().includes(search?.toLowerCase());
      if (matchesSearch) {
        return {
          ...sub
        }
      }
      const cat = SearchSubCategore(search, sub.sub_category_data)?.filter(
        (item: any) => item != undefined
      );
      if (cat.length) {
        return {
          ...sub,
          sub_category_data: SearchSubCategore(search, sub.sub_category_data),
        };
      }
    })
    ?.filter((item: any) => item !== undefined);
}
export default FilterItem;

function SearchSubCategore(search: any, data: any) {
  return data
    ?.map((subCategory: any) => {
      const subcat = SearchItem(search, subCategory?.item_data);
      if (subcat.length) {
        return {
          ...subCategory,
          item_data: subcat,
        };
      }
    })
    ?.filter((item: any) => item != undefined);
}



function SearchItem(search: any, data: any) {
  return data
    ?.map((item: any) => {
      return item?.name?.toUpperCase()?.includes(search.toUpperCase()) ||
        item?.description?.toUpperCase()?.includes(search.toUpperCase())
        ? item
        : undefined;
    })
    ?.filter((item: any) => item != undefined);
}
